import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';

/**
 * Returns if the folderTable is Initialized in mail store
 */
export const isFolderTableInitialized = (): boolean => {
    return getMailStore()?.folders?.folderTable?.size > 0;
};
